// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var DOM__Search$SmartcutsMacros = require("../../devProtocol/DOM__Search.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var DevProtocol__DOM$SmartcutsMacros = require("../../devProtocol/DevProtocol__DOM.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("../../semantics/InnerTextSemantic.bs.js");
var SelectorOverrideWithoutScope$SmartcutsMacros = require("./SelectorOverrideWithoutScope.bs.js");

function t_encode(v) {
  return [
          selectorOverrideWithScope_encode(v[0]),
          Decco.arrayToJson(selectorOverrideWithScope_encode, v[1])
        ];
}

function t_decode(v) {
  var match = Js_json.classify(v);
  if (typeof match === "number") {
    return Decco.error(undefined, "Not a tuple", v);
  }
  if (match.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a tuple", v);
  }
  var match$1 = match._0;
  if (match$1.length !== 2) {
    return Decco.error(undefined, "Incorrect cardinality", v);
  }
  var v0 = match$1[0];
  var v1 = match$1[1];
  var match$2 = selectorOverrideWithScope_decode(v0);
  var match$3 = Decco.arrayFromJson(selectorOverrideWithScope_decode, v1);
  if (match$2.TAG === /* Ok */0) {
    if (match$3.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: [
                match$2._0,
                match$3._0
              ]
            };
    }
    var e = match$3._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[1]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = match$2._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function selectorOverrideWithScope_encode(v) {
  return Js_dict.fromArray([
              [
                "selectorOverride",
                SelectorOverrideWithoutScope$SmartcutsMacros.t_encode(v.selectorOverride)
              ],
              [
                "scope",
                scope_encode(v.scope)
              ]
            ]);
}

function selectorOverrideWithScope_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selectorOverride = SelectorOverrideWithoutScope$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorOverride"), null));
  if (selectorOverride.TAG === /* Ok */0) {
    var scope = scope_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scope"), null));
    if (scope.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selectorOverride: selectorOverride._0,
                scope: scope._0
              }
            };
    }
    var e = scope._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".scope" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selectorOverride._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selectorOverride" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function scope_encode(v) {
  if (v) {
    return [
            "Element",
            elementLocatorInTermsOfStrategy_encode(v._0)
          ];
  } else {
    return ["Document"];
  }
}

function scope_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Document" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Document */0
                  };
          }
      case "Element" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Element */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function elementLocatorInTermsOfStrategy_encode(v) {
  switch (v.TAG | 0) {
    case /* DefaultSelector */0 :
        return [
                "DefaultSelector",
                Selector$SmartcutsMacros.selector_encode(v._0),
                Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1)
              ];
    case /* SelectorOverrides */1 :
        return [
                "SelectorOverrides",
                t_encode(v._0)
              ];
    case /* DefaultSelectorWithOverrides */2 :
        return [
                "DefaultSelectorWithOverrides",
                Selector$SmartcutsMacros.selector_encode(v._0),
                Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1),
                t_encode(v._2)
              ];
    
  }
}

function elementLocatorInTermsOfStrategy_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DefaultSelector" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DefaultSelector */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DefaultSelectorWithOverrides" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$5 = t_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              if (match$5.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* DefaultSelectorWithOverrides */2,
                          _0: match$3._0,
                          _1: match$4._0,
                          _2: match$5._0
                        }
                      };
              }
              var e$2 = match$5._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "SelectorOverrides" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectorOverrides */1,
                      _0: v0._0
                    }
                  };
          }
          var e$5 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyElementLocatorInTermsOfStrategy(elementLocatorInTermsOfStrategy, withPrefix, stringifySelector) {
  switch (elementLocatorInTermsOfStrategy.TAG | 0) {
    case /* DefaultSelector */0 :
        return (
                withPrefix ? "selector=" : ""
              ) + Curry._1(stringifySelector, elementLocatorInTermsOfStrategy._0);
    case /* SelectorOverrides */1 :
        var match = elementLocatorInTermsOfStrategy._0;
        return (
                withPrefix ? "overrides=" : ""
              ) + Belt_Array.map($$Array.append([match[0]], match[1]), (function (param) {
                        return SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride);
                      })).join(", ");
    case /* DefaultSelectorWithOverrides */2 :
        var match$1 = elementLocatorInTermsOfStrategy._2;
        return (
                withPrefix ? "overrides-including-selector=" : ""
              ) + $$Array.append(Belt_Array.map($$Array.append([match$1[0]], match$1[1]), (function (param) {
                            return SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride);
                          })), ["(selector=" + (Curry._1(stringifySelector, elementLocatorInTermsOfStrategy._0) + ")")]).join(", ");
    
  }
}

function stringify(param) {
  return "[" + (Belt_Array.map($$Array.append([param[0]], param[1]), (function (param) {
                    return StringUtils$SmartcutsMacros.quote(SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride));
                  })).join(", ") + "]");
}

function fromArrayOfSelectorOverrideWithoutScope(overrides) {
  return [
          {
            selectorOverride: Belt_Array.getExn(overrides, 0),
            scope: /* Document */0
          },
          Belt_Array.map(Belt_Array.sliceToEnd(overrides, 1), (function (selectorOverride) {
                  return {
                          selectorOverride: selectorOverride,
                          scope: /* Document */0
                        };
                }))
        ];
}

function attemptToLocateSelectorOverrideWithScope(param, timeoutInMilliseconds) {
  var scope = param.scope;
  var selectorOverride = param.selectorOverride;
  if (scope) {
    var selectorOverrides_ancestor = scope._0;
    switch (selectorOverrides_ancestor.TAG | 0) {
      case /* DefaultSelector */0 :
          return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, selectorOverrides_ancestor._1, undefined, undefined, selectorOverrides_ancestor._0);
      case /* SelectorOverrides */1 :
          return attemptToLocate(selectorOverrides_ancestor._0, timeoutInMilliseconds);
      case /* DefaultSelectorWithOverrides */2 :
          var maybeInnerTextSemantic = selectorOverrides_ancestor._1;
          var defaultSelector = selectorOverrides_ancestor._0;
          return attemptToLocate(selectorOverrides_ancestor._2, timeoutInMilliseconds).then(function (result) {
                      if (result.TAG === /* Ok */0) {
                        return Promise.resolve(result);
                      } else {
                        return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, maybeInnerTextSemantic, undefined, undefined, defaultSelector);
                      }
                    });
      
    }
  } else {
    var querySelectorString = SelectorOverrideWithoutScope$SmartcutsMacros.toString(selectorOverride);
    return Util$SmartcutsMacros.waitForPromise2(timeoutInMilliseconds, undefined, (function (param) {
                    var maybeDomElement = document.querySelector(querySelectorString);
                    if (maybeDomElement == null) {
                      return Promise.resolve(/* PredicateNotSatisfied */0);
                    } else {
                      return Promise.resolve({
                                  TAG: /* PredicateSatisfied */0,
                                  _0: maybeDomElement
                                });
                    }
                  })).then(function (result) {
                if (result.TAG === /* Ok */0) {
                  var domElement = result._0;
                  switch (domElement.TAG | 0) {
                    case /* PredicateDidResolveTo */0 :
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: domElement._0
                                  });
                    case /* TimedOut */1 :
                    case /* PredicateTimedOut */2 :
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* QuerySelectorOverridesTimedOut */8,
                                      _0: [selectorOverride]
                                    }
                                  });
                    
                  }
                } else {
                  var jsPromiseError = result._0;
                  if (jsPromiseError.TAG !== /* UncaughtPredicateError */0) {
                    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
                  }
                  var jsPromiseError$1 = jsPromiseError._0;
                  console.error("Error for selector " + querySelectorString, jsPromiseError$1);
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                TAG: /* ErrorWhileSearchForElement */9,
                                _0: jsPromiseError$1
                              }
                            });
                }
              });
  }
}

function attemptToLocate(param, timeoutInMilliseconds) {
  var backupSelectorOverridesWithScopes = param[1];
  return attemptToLocateSelectorOverrideWithScope(param[0], timeoutInMilliseconds).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: result._0
                          });
              } else {
                return Belt_Array.reduce(backupSelectorOverridesWithScopes, Promise.resolve({
                                TAG: /* Error */1,
                                _0: result._0
                              }), (function (promisedResult, currBackupSelectorOverrideWithScope) {
                              return promisedResult.then(function (result) {
                                          if (result.TAG === /* Ok */0) {
                                            return Promise.resolve(result);
                                          } else {
                                            return attemptToLocateSelectorOverrideWithScope(currBackupSelectorOverrideWithScope, timeoutInMilliseconds);
                                          }
                                        });
                            }));
              }
            });
}

var ContentScriptLocator = {
  attemptToLocate: attemptToLocate
};

function attemptToLocate$1(param, tabId, timeoutInMilliseconds) {
  var backupSelectorOverridesWithScopes = param[1];
  return attemptToLocateSelectorOverrideWithScope$1(param[0], tabId, timeoutInMilliseconds).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: result._0
                          });
              } else {
                return Belt_Array.reduce(backupSelectorOverridesWithScopes, Promise.resolve({
                                TAG: /* Error */1,
                                _0: /* CdpUnableToGetDocument */1
                              }), (function (promisedResult, currBackupSelectorOverrideWithScope) {
                              return promisedResult.then(function (result) {
                                          if (result.TAG === /* Ok */0) {
                                            return Promise.resolve(result);
                                          } else {
                                            return attemptToLocateSelectorOverrideWithScope$1(currBackupSelectorOverrideWithScope, tabId, timeoutInMilliseconds);
                                          }
                                        });
                            }));
              }
            });
}

function attemptToLocateSelectorOverrideWithScope$1(param, tabId, timeoutInMilliseconds) {
  var scope = param.scope;
  if (scope) {
    var selectorOverrides_ancestor = scope._0;
    switch (selectorOverrides_ancestor.TAG | 0) {
      case /* DefaultSelector */0 :
          return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaSearch(undefined, undefined, undefined, true, selectorOverrides_ancestor._1, tabId, undefined, undefined, selectorOverrides_ancestor._0).then(function (result) {
                      if (result.TAG === /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: result._0
                                  });
                      } else {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result._0
                                  });
                      }
                    });
      case /* SelectorOverrides */1 :
          return attemptToLocate$1(selectorOverrides_ancestor._0, tabId, timeoutInMilliseconds);
      case /* DefaultSelectorWithOverrides */2 :
          var maybeInnerTextSemantic = selectorOverrides_ancestor._1;
          var defaultSelector = selectorOverrides_ancestor._0;
          return attemptToLocate$1(selectorOverrides_ancestor._2, tabId, timeoutInMilliseconds).then(function (result) {
                      if (result.TAG === /* Ok */0) {
                        return Promise.resolve(result);
                      } else {
                        return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaSearch(undefined, undefined, undefined, true, maybeInnerTextSemantic, tabId, undefined, undefined, defaultSelector).then(function (result) {
                                    if (result.TAG === /* Ok */0) {
                                      return Promise.resolve({
                                                  TAG: /* Ok */0,
                                                  _0: result._0
                                                });
                                    } else {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: result._0
                                                });
                                    }
                                  });
                      }
                    });
      
    }
  } else {
    var querySelectorString = SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride);
    return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaQuerySelector(timeoutInMilliseconds, undefined, /* Document */0, tabId, querySelectorString).then(function (result) {
                if (result.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
                var nodeId = result._0;
                return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeNode) {
                            var arg = Belt_Option.map(maybeNode, (function (node) {
                                    return [
                                            nodeId,
                                            node.backendNodeId
                                          ];
                                  }));
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: (function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                            })("Expected CDP node")
                                      });
                          });
              });
  }
}

var CdpLocator = {
  attemptToLocate: attemptToLocate$1
};

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.selectorOverrideWithScope_encode = selectorOverrideWithScope_encode;
exports.selectorOverrideWithScope_decode = selectorOverrideWithScope_decode;
exports.scope_encode = scope_encode;
exports.scope_decode = scope_decode;
exports.elementLocatorInTermsOfStrategy_encode = elementLocatorInTermsOfStrategy_encode;
exports.elementLocatorInTermsOfStrategy_decode = elementLocatorInTermsOfStrategy_decode;
exports.stringifyElementLocatorInTermsOfStrategy = stringifyElementLocatorInTermsOfStrategy;
exports.stringify = stringify;
exports.fromArrayOfSelectorOverrideWithoutScope = fromArrayOfSelectorOverrideWithoutScope;
exports.ContentScriptLocator = ContentScriptLocator;
exports.CdpLocator = CdpLocator;
/* Util-SmartcutsMacros Not a pure module */
